import { HTTP } from "./http";

let API_SERVER = "";
if (window.location.href.indexOf("8080") > -1) {
  API_SERVER = "http://www.localhost:8888/back-end-endpoint-training-programme.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-training-programme.php";
}

const TrainingProgramme = {
  findByClub(clubId, section) {
    return HTTP.post(API_SERVER, { action: "getProgrammesByClubId", clubId, section });
  },

  show(id) {
    return HTTP.post(API_SERVER, { action: "getProgrammeById", id });
  },

  store(post) {
    return HTTP.post(API_SERVER, { ...post, action: "saveProgramme" });
  },

  update(post) {
    return HTTP.post(API_SERVER, { ...post, action: "editProgramme" });
  },

  delete(id, clubId) {
    return HTTP.post(API_SERVER, { action: "deleteProgramme", id, clubId });
  },

  duplicate(id) {
    return HTTP.post(API_SERVER, { action: "duplicateProgramme", id });
  },
};

export { TrainingProgramme };
